"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// export for common js environments like Node.js, needed to support best practice imports
// allows imports like: const logger = require('lib');
// further usage would be logger.init(...), or logger.info(...)
// without this export, the import would have to be: const logger = require('lib').cleLogger
__export(require("./logger"));
// export for use in typescript and es6 environments
// allows imports like: import { cleLogger } from 'lib'
const cleLogger = require("./logger");
exports.cleLogger = cleLogger;
//# sourceMappingURL=index.js.map